import React from 'react';
import PropTypes from 'prop-types';
import { useProfileImage } from '../../utils';
import logger from '../../../Helpers/logger';

const ProfileImage = ({ imageUri, userId, alt = 'Image', defaultImg, className, setImageSource }) => {
    const { src } = useProfileImage({ imageUri, userId, defaultImg, setImageSource });

    if (src.startsWith('blob:')) {
        return (
            <img
                src={src}
                alt={alt}
                className={className}
                loading="lazy"
                referrerPolicy="no-referrer"
                onError={e => {
                    logger.debug('image blob render error', e);
                    e.currentTarget.src = defaultImg;
                }}
            />
        );
    }

    return (
        <img
            src={src || defaultImg}
            alt={alt}
            className={className}
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={e => {
                logger.debug('Profile image render error', e);
                e.currentTarget.src = defaultImg;
            }}
        />
    );
};

export default ProfileImage;

ProfileImage.propTypes = {
    imageUri: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Blob)]),
    userId: PropTypes.string,
    alt: PropTypes.string,
    defaultImg: PropTypes.string,
    className: PropTypes.string,
    setImageSource: PropTypes.func,
};
